/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 *  
 *  Tracking utils - depend on GA tracking
 */

var TrackingUtils = function(){};


/**
 * Event tracking abstraction
 * @param {string} eventCategory
 * @param {string} eventAction
 * @param {string} eventLabel
 * @param {string} eventValue
 * @returns null
 */
TrackingUtils.trackEvent = function(eventCategory, eventAction, eventLabel, eventValue){
	if(window.ga && ga.create) {
		ga('send', 'event', eventCategory, eventAction, eventLabel, eventValue);
	}
};


/**
 * Init tracking of external links
 */
TrackingUtils.initExternalLinkTracking = function(){
	$('a').click(function(e){
		var link = $(this);
		// only apply to external links and if GA is loaded
		if(!link.prop('hostname').match(window.location.hostname) && window.ga && ga.create) {
			var catNameExtLink = 'External link';
			var catNameMailLink = 'E-mail link';
			var linkUrl = String(link.attr('href'));
			var linkTarget = String(link.attr('target')).toLowerCase();
			var curPageUrl = window.location.pathname;

			// email links
			if(linkUrl.toLowerCase().indexOf("mailto:") === 0){
				var email = linkUrl.substr(linkUrl.indexOf(':') + 1);
				TrackingUtils.trackEvent(catNameMailLink, email, curPageUrl);	
				return;
			}

			// all other links
			if(linkTarget === '_blank'){
				// links opened in new window will track normally
				TrackingUtils.trackEvent(catNameExtLink, linkUrl, curPageUrl);	
			} else {
				// links with same window target will finish tracking first
				e.preventDefault();
				ga('send', 'event', {
					eventCategory: catNameExtLink,
					eventAction: linkUrl,
					eventLabel: curPageUrl,
					transport: 'beacon',
					hitCallback: function() {
						window.location = linkUrl;
					}
				});
			}
		}
	});
};
